/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const publishTruckData = /* GraphQL */ `
  mutation PublishTruckData($input: InputTruckData!) {
    publishTruckData(input: $input) {
      IDWarehouse
      load_control_num
      scheduled_pos
      unscheduled_pos
      carrier
      vendor
      dock
      dock_id
      appointment_time
      check_in_time
      po_status
      truck_load_status
      truck_count
      indoor_time
      door
      driver_unload
      door_acknowledge
      detention_status
      truckSequence
      operationType
      underOneHour
      overOneHour
      overOnePointFiveHour
      TruckSequence
      Notes
    }
  }
`;
export const realTimeEventFailed = /* GraphQL */ `
  mutation RealTimeEventFailed($input: GenericEventInput!) {
    realTimeEventFailed(input: $input) {
      eventSource
      eventId
      errorCode
      errorMessage
    }
  }
`;
export const publishIMSAnalyticsLoadStatus = /* GraphQL */ `
  mutation PublishIMSAnalyticsLoadStatus($input: InputIMSAnalyticsLoadStatus!) {
    publishIMSAnalyticsLoadStatus(input: $input) {
      IDWarehouse
      appointment_time
      checkin_time
      door_assign_time
      unloading_time
      released_time
      appointment_count
      checkin_count
      door_assign_count
      unloading_count
      released_count
    }
  }
`;
export const publishDMSTruckData = /* GraphQL */ `
  mutation PublishDMSTruckData($input: InputDMSTruckData!) {
    publishDMSTruckData(input: $input) {
      ID
      Control
      IDTruckVendor
      ScheduledPOs
      UnScheduledPOs
      PO
      POStatus
      Dock
      IDDock
      Door
      Carrier
      Vendor
      IDWarehouseCarrier
      ScheduledTime
      ArrivalTime
      CheckInTime
      InDoorTime
      LumpStartTime
      LumpEndTime
      BillsInTime
      BillsOutTime
      OutDoorTime
      CheckOutTime
      BatchStartDatetime
      TruckLoadStatus
      TruckCount
      DriverUnload
      Backhaul
      Dropped
      Acknowledged
      IDBatch
      IDWarehouse
      IsActiveTruckBatch
      IDVendorCommodity
      CreatedOn
      UpdatedOn
      operationType
      underOneHour
      overOneHour
      overOnePointFiveHour
      TruckSequence
      Notes
    }
  }
`;
export const publishDmsBucketData = /* GraphQL */ `
  mutation PublishDmsBucketData($input: DmsBucketInput!) {
    publishDmsBucketData(input: $input) {
      ID
      WarehouseID
      WarehouseName
      StartDate
      EndDate
      StartTime
      EndTime
      Status
      count {
        over_1_5_hr
        over_1_hr
        under_1_hr
      }
    }
  }
`;
export const createSPRODownloadReport = /* GraphQL */ `
  mutation CreateSPRODownloadReport($input: CreateSPRODownloadReportInput!) {
    createSPRODownloadReport(input: $input) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
export const publishReleaseBanner = /* GraphQL */ `
  mutation PublishReleaseBanner($input: ReleaseBannerInput!) {
    publishReleaseBanner(input: $input) {
      id
      service
      prevVersion
      currentVersion
      isReleaseDone
      isActive
      isDeleted
      forceUpdate
      bannerHeading
      bannerText
      bannerSubtext
      bannerLogo
      bannerDisclaimer
      releaseDate
      notificationType
      startDateTime
      endDateTime
      severity
    }
  }
`;
export const updateSPRODownloadReport = /* GraphQL */ `
  mutation UpdateSPRODownloadReport($input: UpdateSPRODownloadReportInput!) {
    updateSPRODownloadReport(input: $input) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
